import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const TESTIMONIALS = [
  {
    quote:
      "He called me himself before I paid anything and walked me through every single page. For the first time I actually understand what protects my house and my kids.",
    name: "Denise M.",
    role: "Homeowner and mother of three",
    img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    quote:
      "I had a trust from years ago sitting in a drawer. He reviewed it for free, showed me exactly what was missing, and fixed it. No pressure at any point.",
    name: "Robert T.",
    role: "Small business owner",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    quote:
      "As a fellow veteran's spouse, working with someone who served meant everything. The legal review was included and everything was done right the first time.",
    name: "Angela P.",
    role: "Military family",
    img: "https://images.pexels.com/photos/31530222/pexels-photo-31530222.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
];

export const Testimonials = () => (
  <section className="bg-inkdeep py-24 sm:py-36" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Families We Protect</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.06] mt-6">
          Trusted Like <em className="text-gold italic">Family.</em>
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6 mt-14 sm:mt-20">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.12 * i} className="h-full">
            <figure className="h-full bg-surface border border-white/8 rounded-2xl p-8 sm:p-10 flex flex-col hover:border-gold/35 transition-colors duration-500" data-testid={`testimonial-card-${i}`}>
              <Quote size={26} className="text-gold/70" aria-hidden="true" />
              <blockquote className="font-display text-lg sm:text-xl text-cream/90 leading-relaxed italic mt-6 flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-8 pt-6 border-t border-white/8">
                <img src={t.img} alt={t.name} loading="lazy" className="w-14 h-14 rounded-full object-cover border-2 border-gold/50" />
                <div>
                  <p className="text-cream font-semibold text-sm tracking-wide">{t.name}</p>
                  <p className="text-cream/50 text-xs mt-0.5">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
